import { render, staticRenderFns } from "./NameList.vue?vue&type=template&id=7983f918&"
import script from "./NameList.vue?vue&type=script&lang=js&"
export * from "./NameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports